import { DocumentNode, gql } from '@apollo/client'

export const CREATE_MULTIPLE_REGULAR_SLOT: DocumentNode = gql`
    mutation createMultipleRegularSlots(
        $daycareId: Int!
        $childIds: [Int]!
        $days: [Int]
        $start: Time!
        $end: Time!
        $from: Date
        $to: Date
        $dateList: [Date]
        $overwrite: Boolean
        $placeId: Int
        $weekCycle: Int
        $weekOffsets: [Int]
        $referenceDate: Date
    ) {
        createMultipleRegularSlots(
            daycareId: $daycareId
            childIds: $childIds
            days: $days
            start: $start
            end: $end
            from: $from
            to: $to
            dateList: $dateList
            overwrite: $overwrite
            placeId: $placeId
            weekCycle: $weekCycle
            weekOffsets: $weekOffsets
            referenceDate: $referenceDate
        ) {
            occasionalSlots {
                slotId
                date
                start
                end
                slotType
                childName
                childId
                childComplement
                placeName
            }
            regularSlots {
                slotId
                date
                start
                end
                slotType
                childName
                childId
                childComplement
                placeName
            }
            requestSlots {
                slotId
                date
                start
                end
                slotType
                childName
                childId
                childComplement
                placeName
            }
            otherSlots {
                slotId
                date
                start
                end
                slotType
                childName
                childId
                childComplement
                placeName
            }
        }
    }
`

export const GET_REGULAR_SLOTS: DocumentNode = gql`
    query GetRegularSlots($childIds: [Int], $daycareId: Int, $from: Date, $to: Date) {
        getRegularSlots(childIds: $childIds, daycareId: $daycareId, from: $from, to: $to) {
            id
            daycareId
            childName
            childComplement
            childId
            sectionId
            sectionName
            day
            start
            end
            date
            parentId
            parentName
            absence
            type
            cancellationRequests {
                id
                date
                start
                end
                date
                reason
                requestDate
            }
            placeId
            placeName
            placeAddress
            created
            updated
        }
    }
`

export const GET_LAST_REGULAR_SLOT: DocumentNode = gql`
    query getLastRegularSlot($childId: Int, $daycareId: Int!) {
        getLastRegularSlot(childId: $childId, daycareId: $daycareId) {
            id
            daycareId
            childName
            childComplement
            childId
            sectionId
            sectionName
            day
            start
            end
            date
            parentId
            parentName
            absence
            type
            cancellationRequests {
                id
                date
                start
                end
                reason
                requestDate
            }
            placeId
            placeName
            placeAddress
            created
            updated
        }
    }
`

export const DELETE_REGULAR_SLOT: DocumentNode = gql`
    mutation deleteRegularSlot($regular_slot_id: Int!, $daycare_id: Int!) {
        deleteRegularSlot(regular_slot_id: $regular_slot_id, daycare_id: $daycare_id)
    }
`

export const DELETE_MULTIPLE_REGULAR_SLOTS: DocumentNode = gql`
    mutation deleteMultipleRegularSlots($regularSlotIds: [Int]!, $daycareId: Int!) {
        deleteMultipleRegularSlots(regularSlotIds: $regularSlotIds, daycareId: $daycareId)
    }
`
